module.exports = __webpack_public_path__ + "static/media/notification_error_2.31afcaf4.svg";